import React from "react";

import "./Acknowledgements.css";

const Acknowledgements = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_info">
      <h1 className="headtext__cormorant">Acknowledgements</h1>

      <div className="app__author-content">
        <div className="app__author-content_quote">
          <p className="p__opensans_lower_case">
            I would like to thank the USC Center for Sustainability Solutions
            for selecting and funding this project proposal for the Fall
            2022-Spring 2023 school year. Namely Professor Mahta Moghaddam,
            Professor Detlof von Winterfeldt, and Ms. Jennifer Sosenko. I would
            also like to thank my University of Southern California faculty
            advisors, Professor Brighde Mullins and Professor Thomas Mueller,
            for their expertise and knowledge in the fields of literary editing
            and publishing and visual arts respectively. Without them I truly
            would have been at a loss for guidance and courage. I would lastly
            like to thank USC computer science major Jacob Jun for his creation
            of this website page. For his knowledge, kindness, and expertise in
            this field of study.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default Acknowledgements;
